
import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles/index";
import { Modal, Button, Alert } from "react-bootstrap";
import TextField from "@material-ui/core/TextField";
import CircularProgress from "@material-ui/core/CircularProgress";
import axios from "axios";
import { useFormik } from "formik";
import * as Yup from "yup";

const useStyles = makeStyles({
  list: {
    width: 400,
    height: "100vh",
  },
  card: {
    margin: "30px",
  },
  pointer: {
    cursor: "pointer",
  },
  progresRoot: {
    width: "100%",
    padding: "32px 16px",
  },
  progress: {
    margin: "auto",
    display: "block",
    color: "#072C8C",
  },
});
const initialValues = {
  name: "",
  number: "",
};

export default function Edit(props) {
  const classes = useStyles();
  const {
    onHide,
    show,
    onCards,
    chooseCardId,
    onCardChoose,
    skip,
    take,
    sortField,
    orderBy,
    filterInputs,

  } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [isEditLoading, setIsEditLoading] = useState(false);

  const onPutCard = (values, resetForm, setSubmitting) => {
    setIsEditLoading(true)
    const card = {
      id: chooseCardId,
      name: values.name,
      number: values.number,

    };
    axios
      .put(
        `${process.env.REACT_APP_API_URL}card/${chooseCardId}`,
        card
      )
      .then(() => {
        onHide(false);
        resetForm();
        setSubmitting(false);
        onCards(orderBy, sortField, skip, take, filterInputs,);
        setIsEditLoading(false)
      })
      .catch((err) => {
        let message =
          typeof err.response !== "undefined"
            ? err.response.data.checks ? err.response.data.checks.number : err.response.data.message && err.response.data.message
            : err.message;
        setIsError(message);
        setIsEditLoading(false)
      });

  };

  const EditSchema = Yup.object().shape({
    name: Yup.string()
      .required("Ad tələb olunur."),
      number: Yup.number().typeError('Zəhmət olmasa ancaq rəqəm daxil edin')
      .required('Kart nömrəsi tələb olunur.'),

  });


  const getInputClasses = (filedName) => {
    if (formik.touched[filedName] && formik.errors[filedName]) {
      return true;
    }
    if (formik.touched[filedName] && !formik.errors[filedName]) {
      return false;
    }

    return false;
  };

  const formik = useFormik({
    initialValues,
    validationSchema: EditSchema,
    onSubmit: (values, { resetForm, setSubmitting }) => {
      onPutCard(values, resetForm, setSubmitting);
    },
  });

  const { setFieldValue } = formik;


  useEffect(() => {
    setIsLoading(true);
    onCardChoose(chooseCardId)
      .then((res) => {

        setFieldValue("name", res.data.name);
        setFieldValue("number", res.data.number);

        setIsLoading(false);
        setIsError(false);
      })
      .catch((err) => {
        setIsLoading(false);
        setIsError(true);
      });
  }, [chooseCardId, onCardChoose, setFieldValue]);

  return (
    <Modal
      size="md"
      aria-labelledby="edit"
      centered
      className="modal pr-0"
      show={show}
      onHide={onHide}
    >
      {isLoading ? (
        <div className={classes.progresRoot}>
          <CircularProgress className={classes.progress} />
        </div>
      ) : !isLoading ? (
        <form onSubmit={formik.handleSubmit}>
          <Modal.Header closeButton>
            <Modal.Title id="edit">Düzəliş et</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="col-12 pl-4 pr-4">
              <div className="row">
                <div className="col-12 col-md-12 col-lg-12">
                  <div className="w-100 pt-2 pb-3 d-flex flex-wrap">

                    <TextField
                      id="name"
                      name="name"
                      label="Ad"
                      placeholder="Ad"
                      className="w-100"
                      error={getInputClasses("name")}
                      {...formik.getFieldProps("name")}
                    />
                  </div>
                  {formik.touched.name && formik.errors.name ? (
                    <div className="fv-plugins-message-container">
                      <div className="fv-help-block">{formik.errors.name}</div>
                    </div>
                  ) : null}
                </div>

                <div className="col-12 col-md-12 col-lg-12">
                  <div className="w-100 pt-2 pb-3 d-flex flex-wrap">

                    <TextField
                      id="number"
                      name="number"
                      label="Kart nömrəsi"
                      placeholder="Kart nömrəsi"
                      className="w-100"
                      type='text'
                      InputProps={{inputProps:{min:0}}}
                      onKeyPress={(event) => {
                        if (event?.key === '-' || event?.key === '+' ) {
                          event.preventDefault();
                        }
                      }}
                      error={getInputClasses("number")}
                      {...formik.getFieldProps("number")}
                    />
                  </div>
                  {formik.touched.number && formik.errors.number ? (
                    <div className="fv-plugins-message-container">
                      <div className="fv-help-block">
                        {formik.errors.number}
                      </div>
                    </div>
                  ) : null}
                  {isError && (
                    <div className="fv-plugins-message-container">
                      <div className="fv-help-block MuiFormLabel-root Mui-error">
                        {isError}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="light"
              onClick={() => {
                onHide(false);
                formik.resetForm();
              }}
            >
              Ləğv et
            </Button>
            <Button type="submit" className={isEditLoading ? "px-9" : ""}>
              <span>Düzəliş et</span>
              {isEditLoading && (
                <span className="ml-3 spinner spinner-white"></span>
              )}
            </Button>
          </Modal.Footer>
        </form>
      ) : (
        <div className="p-5">
          <Alert variant="info">Xəta baş verdi.</Alert>
        </div>
      )}
    </Modal>
  );
}
